import IconArrowTriangularDown from '@uilib/assets-business-icons/IconArrowTriangularDown';

import React from 'react';
import FlexContainer from '@uilib/core/FlexContainer/FlexContainer';
import Button from 'uilib-wrappers/button';

import i18n from 'Services/i18n';

const DropdownButton = React.forwardRef((props, ref) => (
    <Button ref={ref} id={props.id} disabled={props.disabled} onClick={props.toggle} type="secondary">
        <FlexContainer className="no-wrap" align="center">
            <span>{i18n(props.title)}</span>
            <IconArrowTriangularDown fill="currentcolor" />
        </FlexContainer>
    </Button>
));

export default DropdownButton;
